import { z } from 'zod';

import { keysOf, mapRecord, valuesOf } from './object-utilities.js';

export class EnumBuilder<TSpec> {
  build<TKey extends string>(spec: Record<TKey, TSpec>) {
    const extendedSpec = mapRecord(spec, (x) => ({ ...x.value, value: x.key }));
    const values = keysOf(spec);
    const options = valuesOf(extendedSpec);

    return {
      zodEnum: z.enum(values as unknown as [TKey, ...TKey[]]),
      values,
      options,
      spec: extendedSpec,
    };
  }
}
